/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IFormListScope extends ng.IScope {
        //formSection=
        addForm: any;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        formSection: warsApp.models.FormSection;
        formData: any;
        formDataId: string;
        childForms:any;
        editForm:any;
        formId: string;
        parentFormName:string;
    }

    export class FormList {
        constructor() {
        }

        public link($scope: IFormListScope,
            element: JQuery,
            attrs: ng.IAttributes) {
            
        }
        public scope={
            process: "=",
            formSection: "=",
            formData: "=",
            formDataId: "=",
            formId: "=",
            parentFormName:"="
        };

        public templateUrl = './app/views/directives/inputForm/formList.html';
        public controller = ['$scope', 'formDataService','$location', FormListController];
    }

    export class FormListController {
        constructor(private $scope: IFormListScope,
            private formDataService: services.FormDataService,
            private locationService:angular.ILocationService) {
            $scope.addForm = (fs) => this.internalAddForm(fs);
            $scope.editForm = (f) => this.internalEditForm(f);
            this.$scope.childForms = {};

            let foundFormData=Enumerable.from(this.$scope.process.formDatas).singleOrDefault(f => f.id === this.$scope.formDataId);

            if (foundFormData != null && foundFormData.formDataChildren != null && foundFormData.formDataChildren.length > 0) {
                foundFormData.formDataChildren.forEach(c => {
                    let obj= $scope.process.formJson[this.$scope.formSection.form_id][c];

                    if (!obj) {
                        this.$scope.childForms[c] = {};
                    } else {
                        this.$scope.childForms[c] = obj;
                    }
                });
            }
        }

        private internalEditForm(formDataId: string) {
            var url = '/ProcessType/' + this.$scope.process.processConfigurationId + '/Process/' +
                this.$scope.process.id + '/Form/' + this.$scope.formSection.form.id + '/FormData/' + formDataId;

            if (this.$scope.formId && this.$scope.formDataId && this.$scope.parentFormName) {
                url += "/ParentForm/" + this.$scope.formId + "/ParentFormDataId/" + this.$scope.formDataId +  "/" + this.$scope.parentFormName;
            }

            this.locationService.url(url);
        }

        private internalAddForm(formSection: warsApp.models.FormSection) {
            this.formDataService.createFormData(this.$scope.process.id, this.$scope.formSection.form.uniqueIdentifier,
            this.$scope.formDataId).then(id => {
                this.$scope.childForms[id] = {};
            });
            
        }
    }
}

warsApp.registerDirective('FormList',[]); 
